import { Select } from "@msuite/ui/form";
import { UserCard } from "@/components/cards";
import type { ProjectMemberController } from "@/forms/project-form";
import { useMembers } from "@/hooks/use-members";

/** Props Interface */
interface ProjectMemberPickerProps {
	label: string;
	isRequired: boolean;
	projectMemberController: ProjectMemberController;
	name: "manager" | "deputyManagers";
	"data-cy"?: string;
}

export function ProjectMemberPicker({
	label,
	isRequired,
	projectMemberController,
	name,
	...props
}: ProjectMemberPickerProps) {
	/** Hooks */
	const { members } = useMembers({ capabilities: ["manage-project"] });

	/** Guard */
	if (!members?.length) return null;

	/** Render */
	return (
		<Select
			label={label}
			control={projectMemberController.control}
			name={name}
			multiple={name === "deputyManagers"}
			options={
				members?.map((member) => ({
					label: `${member.user.firstName} ${member.user.lastName}`,
					value: member.id,
					item: member,
				})) ?? []
			}
			itemNotFoundLabel=""
			renderOption={(item) => (
				<UserCard
					variant="plain"
					userId={item.id as string}
					withPopover={false}
				/>
			)}
			isRequired={isRequired}
			data-cy={props["data-cy"] || "project-member-picker"}
		/>
	);
}
